// Zero demo API: every makeRequest is answered here while demo mode is on.
// Must not import http.helper / config / services / stores (no cycles).

import { resolveWith, type DemoRequest, type DemoRoute } from '../core';
import { approvalRoutes } from './approval.routes';
import { authRoutes } from './auth.routes';
import { dashboardRoutes } from './dashboard.routes';
import { fleetRoutes } from './fleet.routes';
import { notificationRoutes } from './notification.routes';
import { organizationRoutes } from './organization.routes';

export const routes: DemoRoute[] = [
  ...authRoutes,
  ...organizationRoutes,
  ...dashboardRoutes,
  ...fleetRoutes,
  ...approvalRoutes,
  ...notificationRoutes,
];

export function resolveDemoRequest(req: DemoRequest): Promise<unknown> {
  return resolveWith(routes, req);
}
